import React, { useState } from "react";
import { API_URL_LOCALE_BASE } from "../../configuration/config";
import axios from "axios";
import * as XLSX from 'xlsx';

import Swal from 'sweetalert2'
import Loading from "../../Components/shared/Loading/Loading";
import Select from 'react-select';
import { getDataGrafico } from "../../services/service";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 11,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 14 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const Carga = (props: any) => {

    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState('');
    const [filePicked, setFilePicked] = useState(false);
    const [selectGraph, setSelectGraph] = useState({ label: '', value: '' });
    const [valuesSelected, setValuesSelected] = useState([]);

    const uploadFile = (fileParam: any) => {
        let file = fileParam[0];
        setFile(file);
        setFilePicked(true);
    }

    const HandleChange = (e: any) => {
        setFile(e.target.files[0]);
        setFilePicked(true);
    }

    const HandleSubmit = (event: any) => {

        event.preventDefault();
        setIsLoading(true)
        if (filePicked && parseInt(selectGraph.value) > 0) {
            const typeData = {
                headers: {
                    "content-type": "multipart/form-data",
                    'Authorization': "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTg5NTY3NzAsImlhdCI6MTY1ODk1NjcxMCwiaXNzIjoia2VuIiwiZGF0YSI6eyJpZCI6MSwibG9naW5fdGltZSI6MTY1ODk1NjcxMH19.45uOgB5kJN6b171vgpOxKILot0_QM9LdYVI119SNdRc"
                }
            };
            const formData = new FormData();
            formData.append('file_excel', file);
            formData.append('tipoGrafico', selectGraph.value);
            axios.post(API_URL_LOCALE_BASE + 'xlsx_to_json', formData, typeData).then(async (response: any) => {
                let { data } = response;
                if (parseInt(data.status) === 200) {
                    Toast.fire({
                        icon: 'success'
                        , title: 'Archivo Excel Ingresado con Exito!'
                    });
                } else {
                    Toast.fire({
                        icon: "error"
                        , title: "Error: Status " + data.status
                    });
                }
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
            Toast.fire({
                icon: "error"
                , title: "Valide los Datos a Ingresar"
            });
        }
    }


    const HandleChangeEdit = (e: any) => {
        setSelectGraph(e)

    }

    const setDataGraficoForExcel = (data: any) => {
        let arrayAux: any = [];
        data.map((item: any) => {
            let objAux: any = {};
            for (const key in item) {
                for (const key2 in item[key]) {
                    for (const key3 in item[key][key2]) {
                        let auxObj: any = item[key][key2][key3]
                        if (key3 === selectGraph.label) {
                            objAux['nombre'] = auxObj;
                        } else {
                            objAux["- " + key3.toString() + " -"] = auxObj ? auxObj : '-';
                        }
                    }
                }
            }
            arrayAux.push(objAux);
        });
        const updatedItemsDataset: any = [];
        // valuesSelected.forEach((valor: any) => {
        //     let datasetItem = arrayAux.find((item: any) => item.nombre === valor.value);
        //     if (datasetItem) {
        //         updatedItemsDataset.push(datasetItem);
        //     }
        // });
        arrayAux.forEach((item: any) => {
            updatedItemsDataset.push(item);
        });
        return updatedItemsDataset;
    }

    const obtenerExcel = () => {
        console.log('====================================');
        console.log('selectGraph', selectGraph);
        console.log('====================================');
        if (selectGraph.value === '') {
            Toast.fire({
                icon: "error"
                , title: "Debe seleccionar un grafico"
            });
            return;
        }


        //@ts-ignore
        getDataGrafico(selectGraph.value).then(({ data, status }: any) => {


            let apiData: any = data.data.dataGrafico.Hoja1;
            //Creo un nuevo excel
            const wb = XLSX.utils.book_new();

            //Se setean los datos al formato para el excel
            const dataXLS = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));

            console.log('data', dataXLS);

            //Se crea una pagina por cada cada grafico con sus respectivos datos
            XLSX.utils.book_append_sheet(wb, dataXLS, 'Pagina 1');

            //Se descarga el excel
            XLSX.writeFile(wb, "Data " + selectGraph.label + ".xlsx")
        })
    }

    return (
        <>
            {isLoading ? <Loading loading={isLoading} /> : null}
            <div className="card m-2 mt-4">
                <div className="card-header">
                    <h1>Cargar Excel</h1>
                </div>
                <div className="card-body">

                    <form>


                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Seleccionar..."
                            styles={customStyles}
                            closeMenuOnSelect={true}
                            options={props.options.map((item: any) => { return { value: item.id, label: item.name } })}
                            onChange={HandleChangeEdit}
                            value={selectGraph}
                        />
                        <div className="mb-3 mt-5">
                            <label className="form-label">Seleccione el arhcivo excel que desea cargar</label>
                            <input className="form-control" type="file" id="excel" name="excel" onChange={HandleChange} />
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button type="submit" className="btn btn-primary" onClick={HandleSubmit}>Subir Excel</button>
                            <button type="button" className="btn btn-success" onClick={obtenerExcel}>Descargar Excel </button>

                        </div>
                    </form>
                </div>
                <div className="card-footer">

                </div>
            </div>
        </>
    )
}

export default Carga;